module.exports = __webpack_public_path__ + "static/img/gift.d48bb99.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/gift.gif
// module id = fNPp
// module chunks = 6